/**
 *
 * AdministratorBCView
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import * as actions from './actions';
import TenantView from "./TenantView";

class TenantViewContainer extends React.PureComponent {

    componentWillMount() {
        const {params: {id}, handleParams} = this.props;
        if (id) {
            handleParams(id);
        }
    }

    render() {
        return (
            <TenantView {...this.props} />
        );
    }
}

TenantViewContainer.propTypes = {
    params: PropTypes.object,
    handleParams: PropTypes.func,
};

function mapDispatchToProps(dispatch) {
    return {
        handleParams: (id) => dispatch(actions.handleParams(id)),
    };
}

export default connect(null, mapDispatchToProps)(TenantViewContainer);
